import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

//get Groups of User
export const getGroupsOfUser = createAsyncThunk('usersGroupSlice/getGroupsOfUser', async (value) => {
  const response = await axios.get(
    `GetADDetails/GetGroupsInUser?username=${encodeURIComponent(value.userName)}&FQDN=${value.fqdn}`
  );
  return response.data;
});
//get Groups Except User
export const getGroupsExceptUser = createAsyncThunk('usersGroupSlice/getGroupsExceptUser', async (value) => {
  const response = await axios.get(
    `GetADDetails/GetGroupsInExceptUser?username=${encodeURIComponent(value.userName)}&FQDN=${value.fqdn}&OuName=${
      value.ouName
    }`
  );
  return response.data;
});

export const getMembersOfGroup = createAsyncThunk('GetADDetails/GetMembersOfGroup', async (value) => {
  const response = await axios.get(
    `GetADDetails/GetMembersOfGroup?groupName=${encodeURIComponent(value.groupName)}&FQDN=${value.fqdn}`
  );
  return response.data;
});
export const GetMembersOfExceptGroup = createAsyncThunk('GetADDetails/GetMembersOfExceptGroup', async (value) => {
  const response = await axios.get(
    `GetADDetails/GetMembersOfExceptGroup?groupName=${encodeURIComponent(value.groupName)}&ouName=${
      value.ouName
    }&FQDN=${value.fqdn}`
  );
  return response.data;
});

const initialState = {
  groupsOfUser: [],
  groupsOfUserLoading: false,
  groupsOfUserError: null,
  groupsExceptUser: [],
  groupsExceptUserLoading: false,
  groupsExceptUserError: null,
  membersOfGroup: [],
  membersOfExceptGroup: [],
};

const usersGroupSlice = createSlice({
  name: 'usersGroupSlice',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getGroupsOfUser.fulfilled, (state, action) => {
        state.groupsOfUserLoading = false;
        state.groupsOfUser = action.payload;
        state.groupsOfUserError = null;
      })
      .addCase(getGroupsExceptUser.fulfilled, (state, action) => {
        state.groupsExceptUserLoading = false;
        state.groupsExceptUser = action.payload;
        state.groupsExceptUserError = null;
      })
      .addCase(getMembersOfGroup.fulfilled, (state, action) => {
        state.membersOfGroup = action.payload;
      })
      .addCase(GetMembersOfExceptGroup.fulfilled, (state, action) => {
        state.membersOfExceptGroup = action.payload;
      });
  },
});
export default usersGroupSlice.reducer;
